var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",on:{"click":function($event){$event.preventDefault();return _vm.goHome.apply(null, arguments)}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"logo__image"},[_c('span',{staticClass:"visually-hidden"},[_vm._v("hablario.com")])])
}]

export { render, staticRenderFns }